const delay = (t: number, abortSignal?: AbortSignal): Promise<unknown> => {
    return new Promise(resolve => {
        setTimeout(resolve, t, { signal: abortSignal })
    })
}

export default delay